import React, { useState } from "react";
import { Row, Col, Table, Badge, ProgressBar, Button } from "react-bootstrap";
import Plot from "react-plotly.js";

const SystemsConnectionByDeviceType = ({ data }) => {

  const [mode, setMode] = useState("count");

  if (!data) return null;

  const devices = JSON.parse(data);
  const devicesArray = Array.isArray(devices) ? devices : Object.values(devices);

  const colors = {
    active: "#2ca02c",
    inactive: "#ff7f0e",
    never: "#d62728"
  };

  const stateLabels = {
    active: "Active",
    inactive: "Inactive",
    never: "Never Active"
  };

  const states = ["active","inactive","never"];

  // -------- DEVICE GROUP --------

  const getDeviceGroup = (device) => {

    if (!device) return "OTHER";

    if (device.startsWith("PSR")) return "PSR";
    if (device.startsWith("COMBO")) return "COMBO";
    if (device.startsWith("LU")) return "LU";
    if (device.startsWith("LaserGenius")) return "Laser Genius +";
    if (device.startsWith("Platino")) return "Platino Linear";
    if (device.startsWith("Night Train")) return "Night Train";

    return "OTHER";
  };

  const normalized = devicesArray.map(d => ({
    ...d,
    device_group: getDeviceGroup(d.device)
  }));

  // -------- AGGREGATION --------

  const aggregate = (dataset) => {

    const map = {};

    dataset.forEach(d => {

      const group = d.device_group;

      if (!map[group]) {
        map[group] = { active:0, inactive:0, never:0 };
      }

      if (d.stato === "active") map[group].active++;
      if (d.stato === "inactive") map[group].inactive++;
      if (d.stato === "never active") map[group].never++;

    });

    return map;
  };

  const agg = aggregate(normalized);

  const deviceGroups = Object.keys(agg).sort();

  // -------- PERCENT --------

  const percent = (v,total)=>{
    if(!total) return 0;
    return ((v/total)*100).toFixed(1);
  };

  // -------- PLOT --------

  const traces = [];

  states.forEach(state=>{

    const yValues = deviceGroups.map(group=>{

      const total =
        (agg[group]?.active||0) +
        (agg[group]?.inactive||0) +
        (agg[group]?.never||0);

      const value = agg[group]?.[state] || 0;

      return mode==="percent" && total
        ? (value/total)*100
        : value;

    });

    traces.push({

      x: deviceGroups,
      y: yValues,

      type:"bar",

      marker:{color:colors[state]},

      name: stateLabels[state],
      legendgroup: state

    });

  });

  const layout = {

    barmode:"stack",

    height:450,

    legend:{
      orientation:"h",
      x:0.5,
      xanchor:"center",
      y:-0.15
    },

    margin:{t:80,l:60,r:20,b:120},


  };

  return(

  <>

  {/* TITLE */}

  <Row className="mt-1 mb-4">
    <Col md={{ span: 8, offset: 2 }}>
      <h4 className="text-center">
        Analisi per tipologia di dispositivo
      </h4>
    </Col>
  </Row>

  {/* MODE BUTTONS */}

  <Row className="mb-3">
    <Col className="text-center">

      <Button
        variant={mode==="count"?"primary":"outline-primary"}
        onClick={()=>setMode("count")}
        className="me-2"
      >
        Count
      </Button>

      <Button
        variant={mode==="percent"?"primary":"outline-primary"}
        onClick={()=>setMode("percent")}
      >
        %
      </Button>

    </Col>
  </Row>

  {/* CHART */}

  <Row>
    <Col>
      <Plot
        data={traces}
        layout={layout}
        style={{ width:"100%" }}
        config={{ responsive:true }}
      />
    </Col>
  </Row>

  {/* TABLE DASHBOARD */}

  <Row className="mt-4">
    <Col md={{ span:10, offset:1 }}>

      <Table striped bordered hover>

        <thead>
          <tr className="text-center">
            <th>Device</th>
            <th>Active</th>
            <th>Inactive</th>
            <th>Never Active</th>
            <th>Distribution</th>
          </tr>
        </thead>

        <tbody>

        {deviceGroups.map(group=>{

          const active = agg[group]?.active || 0;
          const inactive = agg[group]?.inactive || 0;
          const never = agg[group]?.never || 0;

          const total = active+inactive+never;

          const pActive = percent(active,total);
          const pInactive = percent(inactive,total);
          const pNever = percent(never,total);

          return(

          <tr key={group} className="text-center align-middle">

            <td>
              <b>{group}</b>
              <div style={{fontSize:12,color:"#777"}}>
                {total} devices
              </div>
            </td>

            <td>
              <Badge bg="success">
                {active} ({pActive}%)
              </Badge>
            </td>

            <td>
              <Badge bg="warning" text="dark">
                {inactive} ({pInactive}%)
              </Badge>
            </td>

            <td>
              <Badge bg="danger">
                {never} ({pNever}%)
              </Badge>
            </td>

            <td style={{minWidth:260}}>

              <ProgressBar>

                <ProgressBar variant="success" now={pActive} key={1}/>
                <ProgressBar variant="warning" now={pInactive} key={2}/>
                <ProgressBar variant="danger" now={pNever} key={3}/>

              </ProgressBar>

            </td>

          </tr>

          )

        })}

        </tbody>

      </Table>

    </Col>
  </Row>

  </>

  );

};

export default SystemsConnectionByDeviceType;